import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import Calculator from "./pages/Calculator";
import Products from "./pages/Products";
import TermsConditions from "./pages/TermsConditions";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route element={<Calculator />} path="calculator" />
          <Route element={<Products />} path="products" />
          <Route element={<TermsConditions />} path="termsConditions" />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
